import React from 'react';
import {Languages} from 'enums';
import BootstrapSelect from 'components/CustomSelect/BootstrapSelect';
import Flag from 'assets/svgs/languages/flag.svg';
import FlagActive from 'assets/svgs/languages/flag-black.svg';
import messages from '../messages';

const Language = ({selected, setSelected, notEn, small}) => {
  let languages = Object.values(Languages);

  if (notEn) {
    languages = languages.filter((f) => f.code !== 'EN');
  }

  return (
    <BootstrapSelect
      language
      selected={selected}
      displaySelected
      icon={FlagActive}
      iconActive={Flag}
      options={languages}
      label={messages.languages}
      enableClear
      onClear={() => setSelected(null)}
      onChange={(option) => {
        setSelected(option);
      }}
      className="languages-btn medium"
      btnClass={small ? 'small' : ''}
    />
  );
};

export default Language;
